import { useEffect, useState } from "react";
import { leaveService } from "../../../services/leaveService";
import { formatLeaveBalanceLabel, getLeaveBalanceSummary } from "../../../lib/leaveBalance";
import sessionDB from "../../../utils/sessionDB";

export function LeaveBalanceValue({
  empId,
  leaveTypeId,
  enabled = true,
  fallbackToSession = false,
}) {
  const [label, setLabel] = useState("—");

  useEffect(() => {
    if (!enabled || leaveTypeId == null) {
      setLabel("—");
      return undefined;
    }

    const resolvedEmpId = empId ?? (fallbackToSession ? sessionDB.getEmpId() : undefined);
    if (resolvedEmpId == null || resolvedEmpId === "") {
      setLabel("—");
      return undefined;
    }

    let cancelled = false;
    setLabel("—");

    leaveService
      .getLeaveBalance(resolvedEmpId)
      .then((balances) => {
        if (cancelled) return;
        setLabel(formatLeaveBalanceLabel(getLeaveBalanceSummary(leaveTypeId, balances)));
      })
      .catch((err) => {
        console.error("Failed to load leave balance", err);
        if (!cancelled) setLabel("—");
      });

    return () => {
      cancelled = true;
    };
  }, [empId, leaveTypeId, enabled, fallbackToSession]);

  return label;
}
